import { useImageLoader } from './useImageLoader';

export function useImageResizer() {
  const { loadImage } = useImageLoader();

  const resize = async (imageSrc: string, width: number, height: number): Promise<string> => {
    const image = await loadImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) {
      throw new Error('Could not get canvas context');
    }

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL('image/png');
  };

  return { resize };
}
